// Lightweight Web Audio "success chime" — no asset hosting required.
// Two-note ascending "ding-dong" with a soft bell envelope.
// Browsers gate audio behind a user gesture, so we lazily create the AudioContext
// on first call (which always happens after a click).

let _audioCtx = null;

const ensureCtx = () => {
  if (typeof window === "undefined") return null;
  if (!_audioCtx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _audioCtx = new AC();
  }
  if (_audioCtx.state === "suspended") {
    _audioCtx.resume().catch(() => {});
  }
  return _audioCtx;
};

const playNote = (ctx, freq, startAt, duration, gain = 0.18) => {
  const osc = ctx.createOscillator();
  const env = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, startAt);
  env.gain.setValueAtTime(0.0001, startAt);
  env.gain.exponentialRampToValueAtTime(gain, startAt + 0.02);
  env.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  osc.connect(env);
  env.connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.05);
};

/** Soft, friendly two-note ding for sign-in / login success. */
export const playSignInChime = () => {
  const ctx = ensureCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  // C5 → E5 — quick and light
  playNote(ctx, 523.25, t, 0.18, 0.14);
  playNote(ctx, 659.25, t + 0.12, 0.28, 0.16);
};

/** Bigger, more celebratory three-note chime for waiver completion. */
export const playWaiverChime = () => {
  const ctx = ensureCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  // C5 → E5 → G5 — major triad rise
  playNote(ctx, 523.25, t, 0.20, 0.16);
  playNote(ctx, 659.25, t + 0.14, 0.20, 0.16);
  playNote(ctx, 783.99, t + 0.28, 0.45, 0.20);
  // Soft "shimmer" overtone
  playNote(ctx, 1046.50, t + 0.30, 0.35, 0.08);
};
